import React, { ChangeEvent } from 'react';

import {
  PASSWORD_INPUT,
  PASSWORD_PLACEHOLDER,
  PHONE_MASK_FORMAT,
  PHONE_NUMBER_PLACEHOLDER,
} from '../../../constants';
import Tooltip from '../../../modules/tooltip';
import UiInput from '../../../modules/ui/ui-input/ui-input';

interface IProps {
  setPhonenumber: (value: string) => void;
  setPassword: (value: string) => void;
  submitPassword: () => void;
  setError: React.Dispatch<boolean>;
  phoneNumber: string;
  isError: boolean;
}

const PrimaryBody: React.FC<IProps> = ({
  setPhonenumber,
  setPassword,
  phoneNumber,
  submitPassword,
  isError,
  setError,
}) => (
  <div className="login-form__body">
    <div className="login-form__container-296">
      <div className="login-form__item-input">
        <UiInput
          lg
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            let value = '';
            if (e) {
              value = e.target.value;
              value = value
                .split('+')
                .join('')
                .split(' ')
                .join('')
                .split('-')
                .join('');
            }
            setPhonenumber(value);
            setError(false);
          }}
          error={isError}
          placeholder={PHONE_NUMBER_PLACEHOLDER}
          mask={PHONE_MASK_FORMAT}
          // value={phoneNumber}
        />
      </div>
      <div className="login-form__item-input">
        {/* <Input
          className="input--lg"
          onChange={setPassword}
          type={PASSWORD_INPUT}
        /> */}
        <UiInput
          lg
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setPassword(e.target.value);
            setError(false);
          }}
          placeholder={PASSWORD_PLACEHOLDER}
          type={PASSWORD_INPUT}
          onEnterPress={submitPassword}
          error={isError}
        />
        {isError && (
          <div className="login-form__item-remind">
            <Tooltip
              placement="right"
              title="Для восстановления пароля, обратитесь в службу технической поддержки по телефону: support@cfa.digital"
            >
              <p className="text-4 link">Забыли пароль</p>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default PrimaryBody;
